import {BindingExpr} from '@mintdata/mint-kit/api/properties/PropertyEditorPart';

export enum BindingBehavior
{
    YesAndOffByDefault,
    YesAndOnByDefault,
    YesAndAlwaysOn,
    NotBindable
}

export enum BindingIconPlace
{
    LeftBottom,
    RightBottom,
    CenterBottom,
    LeftTop,
    RightTop,
    CenterTop,
    LeftMiddle,
    RightMiddle,
}

export enum BindingTooltipPlace
{
    Top,
    Right,
    Bottom,
    Left,
}

export enum BindingFormatBehavior
{
    On,
    Off,
    None,
}

export class BindingConfig
{
    private constructor(public readonly behavior:BindingBehavior,
                        public readonly defaultBindingExpr:BindingExpr,
                        public readonly iconPlace:BindingIconPlace = BindingIconPlace.LeftMiddle,
                        public readonly tooltipPlace:BindingTooltipPlace = BindingTooltipPlace.Left,
                        public readonly formatBehavior:BindingFormatBehavior = BindingFormatBehavior.On)
    {
    }

    public static with(defaultBindingExpr:BindingExpr,
                       iconPlace?:BindingIconPlace,
                       tooltipPlace?:BindingTooltipPlace,
                       formatBehavior?:BindingFormatBehavior)
    {
        return new BindingConfig(
            BindingBehavior.YesAndOffByDefault,
            defaultBindingExpr,
            iconPlace,
            tooltipPlace,
            formatBehavior
        );
    }

    public static onByDefault(defaultBindingExpr:BindingExpr,
                              iconPlace?:BindingIconPlace,
                              tooltipPlace?:BindingTooltipPlace,
                              formatBehavior?:BindingFormatBehavior)
    {
        return new BindingConfig(
            BindingBehavior.YesAndOnByDefault,
            defaultBindingExpr,
            iconPlace,
            tooltipPlace,
            formatBehavior
        );
    }

    public static alwaysOn(defaultBindingExpr:BindingExpr,
                           iconPlace?:BindingIconPlace,
                           tooltipPlace?:BindingTooltipPlace,
                           formatBehavior?:BindingFormatBehavior)
    {
        return new BindingConfig(
            BindingBehavior.YesAndAlwaysOn,
            defaultBindingExpr,
            iconPlace,
            tooltipPlace,
            formatBehavior
        );
    }

    public static none()
    {
        return new BindingConfig(BindingBehavior.NotBindable, null);
    }
}
